
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M17.73 12.02L21.71 8.04C22.1 7.65 22.1 7.02 21.71 6.63L17.37 2.29C16.98 1.9 16.35 1.9 15.96 2.29L11.98 6.27L8.00002 2.29C7.80002 2.1 7.55002 2 7.29002 2C7.04002 2 6.78002 2.1 6.59002 2.29L2.25002 6.63C1.86002 7.02 1.86002 7.65 2.25002 8.04L6.23002 12.02L2.25002 16C1.86002 16.39 1.86002 17.02 2.25002 17.41L6.59002 21.75C6.98002 22.14 7.61002 22.14 8.00002 21.75L11.98 17.77L15.96 21.75C16.16 21.95 16.41 22.04 16.67 22.04C16.93 22.04 17.18 21.94 17.38 21.75L21.72 17.41C22.11 17.02 22.11 16.39 21.72 16L17.73 12.02ZM12 9C12.55 9 13 9.45 13 10C13 10.55 12.55 11 12 11C11.45 11 11 10.55 11 10C11 9.45 11.45 9 12 9ZM7.29002 10.96L3.66002 7.34L7.29002 3.71L10.91 7.33L7.29002 10.96ZM10 13C9.45002 13 9.00002 12.55 9.00002 12C9.00002 11.45 9.45002 11 10 11C10.55 11 11 11.45 11 12C11 12.55 10.55 13 10 13ZM12 15C11.45 15 11 14.55 11 14C11 13.45 11.45 13 12 13C12.55 13 13 13.45 13 14C13 14.55 12.55 15 12 15ZM14 11C14.55 11 15 11.45 15 12C15 12.55 14.55 13 14 13C13.45 13 13 12.55 13 12C13 11.45 13.45 11 14 11ZM16.66 20.34L13.03 16.72L16.66 13.09L20.28 16.71L16.66 20.34Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-healing`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconHealing

    ```js
    <b-new-b-icon-healing />
    ```
</docs>


